<div class="row content">
  <div class="marginT30 form-group tab-buttons">
    <div class=" pull-left">
      <a class="bt-back btn btn-border-orange"
        (click)="onClickPrevious()"
        *ngIf="previousShow"
        [ngClass]="{'disabled': !previousEnabled}">
        <em class="fa mrBt" [ngClass]="buttonIcon"></em>
        {{previousLabel}}
      </a>
    </div>

    <div class="pull-right">
      <a class="bt-go btn btn-full-orange "
        (click)="onClickNext()"
        *ngIf="nextShow"
        [ngClass]="{'disabled': !nextEnabled}">
        {{nextLabel}}
        <em class="fa fa-arrow-right mlBt"></em>
      </a>
    </div>
  </div>
</div>
